import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
// Load Highcharts modules
require("highcharts/modules/exporting")(Highcharts);
export default function CompareBar({
    Title,
    Categories,
    Series,
    Max = 100,
    unit = '%',
}) {
    const options = {
        title: {
            text: Title,
        },
        chart: {
            type: 'column',
        },
        plotOptions: {
            column: {
                pointPadding: 0,
                borderWidth: 0,
                dataLabels: {
                    enabled: true,
                    format: '{y}' + unit,
                    inside: true,
                    verticalAlign: 'top',
                    align: 'center',
                    color: 'black',
                }
            }
        },
        xAxis: {
            categories: Categories,
        },
        yAxis: {
            min: 0,
            max: Max,
            title: {
                text: unit
            }
        },
        series: Series,
        // if only one series, hide legend
        legend: {
            enabled: Series?.length > 1,
        },
    };

    return (

        <HighchartsReact
            highcharts={Highcharts}
            options={options}
        />

    )
}
